const root = "/";
const home = "/home";
const createProject = "/create-project";
const postUpdate = "/post-update";
const profile = "/profile";
const myProjects = "/my-projects";
const explore = "/explore";
const updateFeed = "/feed";
const login = "/login";
const signup = "/signup";
const forgottenPassword = "/forgotten-password";
const cropImage = "/crop-image";
const contactUs = "/contact-us";

const editProject = "/edit-project";
const editProjectDetails = "/project-details";
const editProjectImages = "/project-images";
const editProjectLinks = "/project-links";


const settings = "/settings";
const general = "/general";
const links = "/profile-links";
const avatar = "/profile-avatar";
const password = "/change-password";

const navRoutes = {
  root,
  home,
  createProject,
  profile,
  myProjects,
  explore,
  login,
  signup,
  forgottenPassword,
  editProject,
  editProjectDetails,
  editProjectImages,
  editProjectLinks,
  cropImage,
  settings,
  general,
  links,
  avatar,
  password,
  updateFeed,
  contactUs,
  postUpdate,
};

export default navRoutes;
